export default __webpack_public_path__ + "static/media/422-tile.ac8d8c69.svg";